import * as React from "react";
import { Eye, EyeOff } from "lucide-react";
import { cn } from "@/lib/utils";

export interface PasswordInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
}

const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ className, ...props }, ref) => {
    const [showPassword, setShowPassword] = React.useState(false);

    return (
      <div className="relative">
        <input
          type={showPassword ? "text" : "password"}
          inputMode="text"
          enterKeyHint="done"
          className={cn(
            // Mobile: h-12 (48px) for WCAG AA touch-friendly targets (min 44x44px)
            // Desktop: h-10 (40px) for compact design
            "flex h-12 md:h-10 w-full rounded-md border border-input bg-background px-3 py-2 pr-12 text-base md:text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
            // Mobile tap highlight color for better touch feedback
            "[ -webkit-tap-highlight-color:rgba(0,0,0,0.1)]",
            className
          )}
          ref={ref}
          {...props}
        />
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="absolute right-0 top-0 h-full min-h-[48px] md:min-h-[40px] w-12 flex items-center justify-center hover:bg-transparent touch-manipulation"
          tabIndex={-1}
          aria-label={showPassword ? "Hide password" : "Show password"}
        >
          {showPassword ? (
            <EyeOff className="h-5 w-5 text-muted-foreground hover:text-foreground transition-colors" />
          ) : (
            <Eye className="h-5 w-5 text-muted-foreground hover:text-foreground transition-colors" />
          )}
        </button>
      </div>
    );
  }
);

PasswordInput.displayName = "PasswordInput";

export { PasswordInput };
